import { t } from '../lib/i18n';
import { PageHeader } from '../ui/Page';
import { ImportWizard } from './ImportWizard';

export function ImportPage(): React.JSX.Element {
  return (
    <div className="view">
      <PageHeader title={t('nav.import')} description={t('import.description')} />
      <ImportWizard />
    </div>
  );
}
